import { useHeaderContext } from '@/components/header-context';
import { MARGIN_HEADER } from '@/components/animated-header';
import { HEADER_HEIGHT } from '@/constants/layout';
import { useEffect } from 'react';
import { useAnimatedScrollHandler, useSharedValue } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function useAnimatedHeader() {
  const { headerTranslateY } = useHeaderContext();
  const insets = useSafeAreaInsets();
  const totalHeight = HEADER_HEIGHT + (insets.top || 0) + MARGIN_HEADER + 4;

  useEffect(() => {
    headerTranslateY.value = 0;
  }, [headerTranslateY]);

  const scrollY = useSharedValue(0);

  const scrollHandler = useAnimatedScrollHandler({
    onScroll: (event, ctx: { prevY?: number }) => {
      const y = event.contentOffset.y;
      scrollY.value = y;

      // Header Logic
      if (y < 0) {
        headerTranslateY.value = 0;
        ctx.prevY = y;
        return;
      }

      if (ctx.prevY === undefined) {
        ctx.prevY = y;
      }

      const diff = y - ctx.prevY;
      const newTranslateY = headerTranslateY.value - diff;

      // Clamp between -totalHeight and 0
      headerTranslateY.value = Math.max(Math.min(newTranslateY, 0), -totalHeight);

      ctx.prevY = y;
    },
  });

  return {
    headerTranslateY,
    scrollY,
    scrollHandler,
    totalHeight,
    insets,
  };
}
